import { Injectable } from "@angular/core";
import { ApiService } from "../base/api-base.service";
import { NetworkStatusService } from "../network-status.service";
import { FeatureFlagContractService } from "./feature-flag.contract.service";
import { FeatureFlagOfflineService } from "./feature-flag.offline.service";
import { FeatureFlagOnlineService } from "./feature-flag.online.service";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService extends ApiService<FeatureFlagContractService> implements FeatureFlagContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: FeatureFlagOfflineService,
    protected onlineService: FeatureFlagOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  fetchAndUpdate(): void {
        this.service.fetchAndUpdate();
    }

  isFlagEnabled(flagName: string): boolean {
        return this.service.isFlagEnabled(flagName);
    }
}
